import { ButtonIcon } from '@tallink/components-lib'
import React from 'react'

import MorePropTypes from '../../../utils/MorePropTypes'
import Hint from '../Hint/Hint'
import s from './MobileSerialTicket.module.scss'

export default function MobileSerialTicket({ ticket, plusMinusProps }) {
  const { code, nameNarrow, price, title, descriptionNarrow } = ticket
  const { value, decreaseDisabled, increaseDisabled, onDecreaseClick, onIncreaseClick } = plusMinusProps

  return (
    <div id={code}>
      <ButtonIcon
        className={s.button}
        disabled={decreaseDisabled}
        iconSize="original"
        iconType="minus-in-circle-fill"
        onClick={onDecreaseClick}
      />
      <div className={s['text-and-price']}>
        <div className={s.text}>
          <span className={s.name} dangerouslySetInnerHTML={{ __html: nameNarrow }} />
          {(title || descriptionNarrow) && <Hint text={descriptionNarrow} title={title} />}
        </div>
        <div className={s.price}>
          {!!value && <span>{value} × </span>} {price} €
        </div>
      </div>
      <ButtonIcon
        className={s.button}
        disabled={increaseDisabled}
        iconSize="original"
        iconType="plus-in-circle-fill"
        onClick={onIncreaseClick}
      />
    </div>
  )
}

MobileSerialTicket.propTypes = {
  plusMinusProps: MorePropTypes.plusMinusMobileProps.isRequired,
  ticket: MorePropTypes.serialTicket.isRequired
}
